import React from "react";
import CrossAttachmentAssessment from "../../../Assesment/pages/Create_Assessment/Attachment/CrossAttachmentAssessment";

const AttachDisplay = ({ nextQuestion,question }) => {
  return (
    <>
      <div className="  preview_question_box">
        <div className=" col-12 my-3 preview_selected_question">
          <div className="pre_question_no">Q{nextQuestion + 1}</div>
          <div className="pre_question">{question.title}</div>
        </div>
        <div className="col-11 mx-5  mandatory_box">
          {question?.is_mandatory && <span>*Mandatory question</span>}
          {/* <div className="col-6 Mandatory ">{mandatoryOrNot}</div> */}
          {question?.attachments?.length > 0 && (
            <div className="ms-2 gap-2 d-flex">
              {question?.attachments?.map((attachment, index) => (
                <CrossAttachmentAssessment
                  key={index}
                  attachment={attachment}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AttachDisplay;
